/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onInteraction = /* GraphQL */ `subscription OnInteraction($blockId: ID!) {
  onInteraction(blockId: $blockId) {
    blockId
    interactionKey
    data
    participantId
    timestamp
    expires
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnInteractionSubscriptionVariables,
  APITypes.OnInteractionSubscription
>;
export const onParticipantJoin = /* GraphQL */ `subscription OnParticipantJoin($zoneId: ID!) {
  onParticipantJoin(zoneId: $zoneId) {
    zoneId
    participantId
    username
    groups
    authenticated
    active
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnParticipantJoinSubscriptionVariables,
  APITypes.OnParticipantJoinSubscription
>;
export const onParticipantLeave = /* GraphQL */ `subscription OnParticipantLeave($zoneId: ID!) {
  onParticipantLeave(zoneId: $zoneId) {
    zoneId
    participantId
    username
    groups
    authenticated
    active
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnParticipantLeaveSubscriptionVariables,
  APITypes.OnParticipantLeaveSubscription
>;
